<template>
  <div>
    <p class="step-heading">Step {{ step }} of 5 - {{ stepName }}</p>
    <div class="step-bar">
      <span class="step-bar__step" :class="{'step-bar__step--active': (step >= 1 || step === '2a')}"></span>
      <span class="step-bar__step" :class="{'step-bar__step--active': (step >= 2 || step === '2a')}"></span>
      <span class="step-bar__step" :class="{'step-bar__step--active': step >= 3}"></span>
      <span class="step-bar__step" :class="{'step-bar__step--active': step >= 4}"></span>
      <span class="step-bar__step" :class="{'step-bar__step--active': step >= 5}"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    step: {
      type: [Number, String],
      required: true
    },
    stepName: {
      type: String,
      required: true
    }
  }
}
</script>
